export const COLUMNS: string[] = [
	'pages.semitrailers.brand', 'pages.semitrailers.plate', 'pages.semitrailers.description', 'pages.semitrailers.volume',
	'pages.semitrailers.weight', 'pages.semitrailers.pieces', '',
];

export const SELECTORS: string[] = [
	'brand', 'plate', 'description', 'capacity_volume',
	'capacity_weight', 'capacity_pieces'
];
